import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY = {
  universe: [],
  books: [],
  characters: [],
  worlds: [],
  timeline: [],
  news: [],
  media: [],
  lore: [],
};

export const fetchContent = async () => {
  try {
    const { data } = await axios.get(`${API}/content`);
    return { ...EMPTY, ...data };
  } catch (e) {
    console.error("content fetch failed", e);
    return EMPTY;
  }
};

export const sendTransmission = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};
